<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      产品信息
    </div>
    <div class="rj-page-card__content">
      <div v-if="isDistribution" style="display: flex;padding: 0 20px 20px 10px; align-items: flex-end">
        <el-button type="primary" :loading="exportVolumeInformationLoading" @click="exportVolumeInformation">
          导出材料信息
        </el-button>
        <div style="display: inline-flex; gap: 20px; margin-left: 20px;font-weight: 400;font-size: 16px">
          <span>预估体积(CBM): <span style="font-weight: 700;margin: 0 5px 0 10px">{{ Number(estimatedVolume).toFixed(2) ?? 'N/A' }}</span>m³</span>
          <span>预计重量: <span style="font-weight: 700;margin: 0 5px 0 10px">{{ Number(estimatedGrossWeight).toFixed(2) ?? 'N/A' }}</span>kg</span>
        </div>
      </div>
      <div class="table">
        <el-table
          :data="productList"
          border
          show-summary
          :summary-method="getSummaries"
          max-height="400"
        >
          <el-table-column type="index" width="70" label="序号" align="left" />
          <el-table-column prop="salesInvoiceName" label="产品名称" align="left" min-width="130" />
          <el-table-column prop="productName" label="产品型号" align="left" min-width="130" />
          <!--国际服务独立销售的单据-->
          <el-table-column v-if="isShowInternationalServiceOrders===1" prop="serviceLife" label="数量" align="left" width="50" />
          <el-table-column v-if="isShowInternationalServiceOrders===0" prop="productNum" label="数量" align="left" width="50" />
          <el-table-column prop="unit" label="单位" align="left" width="50" />
          <el-table-column prop="productPriceSigle" label="单价" align="right" header-align="left" width="100" />
          <el-table-column prop="orderAmount" label="订单金额" align="right" header-align="left" width="100" />
          <el-table-column prop="settlementAmount" label="实际结算金额" align="right" header-align="left" width="100" />
          <template v-if="form.departmentCode && (form.departmentCode.includes('000063') || form.departmentCode.includes('000036') || form.departmentCode.includes('000101'))">
            <el-table-column prop="expectedDeliveryDate" label="期望齐套日期" align="left" min-width="150" />
          </template>
          <template v-if="form.departmentCode && (form.departmentCode.includes('000063') || form.departmentCode.includes('000036') || form.departmentCode.includes('000101'))">
            <el-table-column prop="expectedShippingDate" label="期望发货日期" align="left" min-width="150" />
          </template>
          <template v-if="form.departmentCode && (form.departmentCode.includes('000063') || form.departmentCode.includes('000036') || form.departmentCode.includes('000101'))">
            <el-table-column prop="expectedArrivalDate" label="期望到货日期" align="left" min-width="150" />
          </template>
          <template v-if="!(form.departmentCode && (form.departmentCode.includes('000063') || form.departmentCode.includes('000036') || form.departmentCode.includes('000101')))">
            <el-table-column prop="expectedDeliveryDate" label="期望发货日期" align="left" min-width="130" />
          </template>
          <el-table-column prop="beforeSplitProductPriceSigle" label="拆分前单价" align="right" header-align="left" width="100" />
          <el-table-column prop="powerCordSpecification" label="电源线规格" align="left" width="100" />
          <el-table-column prop="pname" label="是否购买PSC" align="left" width="100">
            <template v-slot="{row}">
              {{ row.isPsc?'是':'否' }}
            </template>
          </el-table-column>
          <el-table-column prop="serviceDesc" label="服务备注" align="left" width="100" />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { MathMulti, MathAdd } from '@/libs/util';
import { exportContractExcel, getContractProductVolume } from '@/API/international';
export default {
  // 产品列表
  name: 'ViewProductList',
  data () {
    return {
      loading: false,
      productList: [],
      isShowInternationalServiceOrders: 0, // 是否是国际服务订单,0国内,1国际,用于控制电源线字段是否显示
      estimatedVolume: 0,
      estimatedGrossWeight: 0,
      exportVolumeInformationLoading: false,
      contractNum: '',
      isDistribution: false
    };
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {};
      }
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    projectName: {
      type: String,
      default: ''
    },
    orderUnit: {
      type: String,
      default: ''
    },
    soldCountry: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 数量总计
    AmountTotal () {
      let cont = 0;
      this.productList.map((item) => {
        if (item) {
          if (!item.expectedDeliveryDate) {
            item.expectedDeliveryDate = '一';
          }
          if (!item.expectedShippingDate) {
            item.expectedShippingDate = '一';
          }
          if (!item.expectedArrivalDate) {
            item.expectedArrivalDate = '一';
          }
        }
        if (this.isShowInternationalServiceOrders === 1 && item.serviceLife) {
          cont += item.serviceLife;
        } else if (item.productNum) {
          cont += item.productNum;
        }
      });
      return cont;
    },
    // 订单金额总计
    computePriceTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        // let itemcont = MathMulti(item.productNum, item.productPriceSigle);
        if (item.orderAmount) {
          cont = MathAdd(item.orderAmount, cont);
        }
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    // 实际结算金额总计
    settlementSumTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    // 拆分前单价总计
    beProductUnitPriceTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        if (this.isShowInternationalServiceOrders === 1) {
          let itemcont = MathMulti(item.serviceLife, item.beforeSplitProductPriceSigle);
          cont = MathAdd(itemcont, cont);
        } else {
          let itemcont = MathMulti(item.productNum, item.beforeSplitProductPriceSigle);
          cont = MathAdd(itemcont, cont);
        }
      });
      return cont;
    }
  },

  methods: {
    async init () {},
    // 合计行的计算
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.AmountTotal;
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = this.computePriceTotal;
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.settlementSumTotal;
        }
        if (column.label === '拆分前单价') {
          sums[index] = this.beProductUnitPriceTotal;
        }
      });
      return sums;
    },
    exportVolumeInformation () {
      this.exportVolumeInformationLoading = true;

      let params = {
        contractNum: this.contractNum,
        projectName: this.projectName,
        partnerName: this.orderUnit,
        soldCountry: this.soldCountry
      };
      exportContractExcel(params).then((res) => {
        this.exportVolumeInformationLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileReg = /filename=(.+)\.xlsx/;
        const fileName = res.headers['content-disposition'].match(fileReg)[0].replace(/"/, '').split('=')[1];
        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {
        this.exportVolumeInformationLoading = false;
      });
    },
    getVolumeInformation () {
      const params = {
        soldCountry: this.soldCountry,
        contractNum: this.contractNum
      };
      getContractProductVolume(params).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.estimatedVolume = json.data.estimatedVolume;
          this.estimatedGrossWeight = json.data.estimatedGrossWeight;
        }
      });
    }
  },
  watch: {
    soldCountry: {
      handler (newVal) {
        if (this.contractNum && newVal) {
          this.getVolumeInformation();
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.isShowInternationalServiceOrders = Number(this.$route.query.isShowInternationalService);
    this.contractNum = this.$route.params.contractNum;
    this.isDistribution = this.$route.params.contractType === '国际分销下单';
    if (this.contractNum && this.soldCountry) {
      this.getVolumeInformation();
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
